import { useEffect, useRef, useState } from 'react';

let globalAudio = null;
let isUnlocked = false;
let pendingPlay = false; // ← Nouveau : mémoriser si un son attend

export function useNotificationAudio() {
  const [audioReady, setAudioReady] = useState(isUnlocked);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!globalAudio) {
      globalAudio = new Audio('/sounds/s2.wav');
      globalAudio.volume = 0.6;
      globalAudio.preload = 'auto';
      globalAudio.load();
    }
    audioRef.current = globalAudio;

    const unlockAudio = () => {
      if (isUnlocked) return;
      isUnlocked = true;
      setAudioReady(true);

      // ← Jouer le son en attente si une notification est arrivée avant l'unlock
      if (pendingPlay && audioRef.current) {
        pendingPlay = false;
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(() => {});
      }
    };

    if (!isUnlocked) {
      // ← Pas de { once: true } pour éviter la perte des listeners
      document.addEventListener('click', unlockAudio);
      document.addEventListener('keydown', unlockAudio);
      document.addEventListener('touchstart', unlockAudio, { passive: true });
    } else {
      setAudioReady(true);
    }

    return () => {
      document.removeEventListener('click', unlockAudio);
      document.removeEventListener('keydown', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
    };
  }, []);

  const playNotification = async () => {
    if (!audioRef.current) return false;

    if (!isUnlocked) {
      // ← Au lieu de juste retourner false, mémoriser l'intention
      pendingPlay = true;
      // Vibration comme fallback immédiat
      if ('vibrate' in navigator) navigator.vibrate(200);
      return false;
    }

    try {
      audioRef.current.currentTime = 0;
      await audioRef.current.play();
      return true;
    } catch (error) {
      if ('vibrate' in navigator) navigator.vibrate(200);
      return false;
    }
  };

  return { playNotification, audioReady, isUnlocked };
}